import { NextSeo } from 'next-seo';
import React, { FC } from 'react';
import { Box, BoxProps } from '@chakra-ui/react';
import { Navbar } from './chakraUIPro/Navbar';

interface PageProps extends BoxProps {
  children: React.ReactNode;
  seoOptions?: any;
  showNav: boolean;
}

const Page: FC<PageProps> = ({ children, seoOptions, showNav, ...props }) => (
  <Box bgColor='bg-default'>
    <NextSeo title='eezi' description='' {...seoOptions} />
    {showNav && <Navbar />}

    <Box maxW='7xl' mx='auto' px={8} textAlign='left' {...props}>
      {children}
    </Box>
  </Box>
);

export default Page;
